import React, {Component} from 'react';

export default class AddNewCategory extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showAddRow: false
        }
    }

    handleNewCategoryPress = (evt) => {
        if (evt.key === "Enter") {
            this.handleNewCategory()
        }
    };

    handleNewCategoryClick = (evt) => {
        this.handleNewCategory()
    };

    handleNewCategory() {
        this.props.addCategory(this.categoryName.value, this.props.refreshLinks)
        this.setState({
            showAddRow: false
        })
    }

    handleShowAddRow = () => {
        this.setState({
            showAddRow: true
        })
    };

    render() {
        return (
            <tbody>
                <tr>
                    <td style={{backgroundColor: "#eee", textAlign: "center"}}>
                        { this.state.showAddRow ? (
                            <span>
                                <input type="text"
                                       id="categoryName"
                                       autoFocus="true"
                                       onKeyPress={this.handleNewCategoryPress}
                                       ref={(input) => { this.categoryName = input; }}
                                />
                                <img alt="Add new category" src="/img/add.svg" id="addCategory"
                                     style={{marginLeft: "10px", cursor: "pointer", width: "23px", height: "23px"}}
                                     onClick={this.handleNewCategoryClick}/>
                            </span>
                            ) : (
                            <img alt="Add new category" src="/img/add.svg" id="showAddRow"
                                 style={{cursor: "pointer", width: "23px", height: "23px"}}
                                 onClick={this.handleShowAddRow}/>
                            )
                        }
                    </td>
                </tr>
            </tbody>
        )
    }
}

AddNewCategory.propTypes = {
    addCategory: React.PropTypes.func.isRequired,
    refreshLinks: React.PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/dashboard/categories/AddNewCategory.js